
import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { isEmpty } from 'underscore';
import t from 'react-translate';

// Actions
import { getDraftCommunications } from 'redux/actions/course-communications';

// Selectors
import { getDraftCommunicationIds, isDraftCommunicationsLoaded } from 'redux/selectors/course-communications';
import EmptyList from 'shared/components/empty-list';
import CommunicationItem from 'course_communications/components/communication-item/communication-item';
import LoadingPlaceholder from './loading-placeholder';
import PageIntro from './page-intro';

const mapDispatchToProps = {
  fetchDrafts: getDraftCommunications,
};

const DraftCommunications = (props: typeof mapDispatchToProps) => {
  const catalogId = useSelector((state) => state.app.currentCatalogId);

  const { fetchDrafts } = props;

  useEffect(() => {
    if (catalogId) {
      fetchDrafts({
        catalogId,
      });
    }
  }, [catalogId, fetchDrafts]);

  const draftCommunicationIds = useSelector((state) => getDraftCommunicationIds(state));

  const isLoaded = useSelector((state) => isDraftCommunicationsLoaded(state));

  return (
    <React.Fragment>
      { !isLoaded && <LoadingPlaceholder /> }
      { isLoaded && (
        <React.Fragment>
          <PageIntro
            title={t.COURSE_COMMUNICATIONS.TABS.TITLE.DRAFTS()}
            description={t.COURSE_COMMUNICATIONS.TABS.DESCRIPTION.DRAFTS()}
          />
          {isEmpty(draftCommunicationIds)
            ? <EmptyList icon='drafts' description={t.COURSE_COMMUNICATIONS.NO_CONTENT.DRAFTS()} />
            : (
              <div className='pt-6'>
                {
                  draftCommunicationIds.map(communicationId => (
                    <div className='mb-4' key={communicationId.toString()}>
                      <CommunicationItem communicationId={communicationId} showOwnerActivity />
                    </div>
                  ))
                }
              </div>
            )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

const ConnectedDraftCommunications = connect<{}, typeof mapDispatchToProps>(
  (state) => ({}),
  mapDispatchToProps as any,
)(DraftCommunications);

export default ConnectedDraftCommunications;
